import { Instance } from 'mobx-state-tree'
import { ThreeCardDailyGameStatsModelBase } from './ThreeCardDailyGameStatsModel.base'

/* The TypeScript type of an instance of ThreeCardDailyGameStatsModel */
export interface ThreeCardDailyGameStatsModelType extends Instance<typeof ThreeCardDailyGameStatsModel.Type> {}

/* A graphql query fragment builders for ThreeCardDailyGameStatsModel */
export {
  selectFromThreeCardDailyGameStats,
  threeCardDailyGameStatsModelPrimitives,
  ThreeCardDailyGameStatsModelSelector
} from './ThreeCardDailyGameStatsModel.base'

/**
 * ThreeCardDailyGameStatsModel
 */
export const ThreeCardDailyGameStatsModel = ThreeCardDailyGameStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
